import { render } from "./AddReceptionStockPage.vue?vue&type=template&id=50e66685&ts=true"
import script from "./AddReceptionStockPage.vue?vue&type=script&lang=ts"
export * from "./AddReceptionStockPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__